import { baseUri } from "../commoms";

const VideoPlayer = () => {
    return <video controls className="grid-row-start-2 grid-row-end-4 grid-column-start-1 grid-column-end-4">
            <source src={baseUri +"/media?filename=ttp_tv.mp4"} type="video/mp4"/>
        </video>
}

export default VideoPlayer;